export default __webpack_public_path__ + "static/media/My-Cart.aa228d9c.jpg";